import { CONTACT } from "../../data/content";
import { Reveal } from "../motion/Reveal";

export const Footer = () => (
  <footer
    id="contact"
    data-testid="site-footer"
    className="border-t border-[var(--hem-border)] bg-[var(--hem-bg)] px-6 md:px-12 py-14 sm:py-20 md:py-32"
  >
    <div className="mx-auto max-w-[1500px]">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
        <Reveal>
          <div className="flex items-center gap-3">
            <span className="text-[var(--hem-needle)] text-base leading-none">✦</span>
            <span className="font-serif-display text-xl tracking-tight">Hemlock Labs</span>
          </div>
          <p className="mt-4 font-mono-tech text-[11px] uppercase tracking-[0.25em] text-[var(--hem-muted)]">
            {CONTACT.note}
          </p>
        </Reveal>

        <Reveal delay={0.08} className="md:text-right">
          <div className="font-mono-tech text-[10px] uppercase tracking-[0.3em] text-[var(--hem-muted)] mb-4">
            Office
          </div>
          <p className="font-serif-display italic text-2xl text-[var(--hem-text)]">
            {CONTACT.address}
          </p>
        </Reveal>
      </div>

      <div className="mt-12 sm:mt-20 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 border-t border-[var(--hem-border)] pt-8 font-mono-tech text-[10px] uppercase tracking-[0.25em] text-[var(--hem-muted)]">
        <span>© {new Date().getFullYear()} Hemlock Labs</span>
        <span>Privately held</span>
      </div>
    </div>
  </footer>
);
